import Component from './EditForm.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionEditForm', Component);
  },
};
